module.exports = __webpack_public_path__ + "img/xiaozhan.4aeca0a6.gif";